<template>
  <v-content>
    <v-container fluid grid-list-md text-lg-center>
      <v-layout class="login-container" align-center justify-center row wrap>
        <v-flex md12 xs12>
          <v-flex text-md-center text-lg-center md4 xs4 offset-md4 offset-xs4 order-xl2>
            <span
              autoid="lbl-log-in-sub-header"
              class="login-header-label"
            >{{ $lang.messages.log_in }}</span>
          </v-flex>
        </v-flex>
        <v-form ref="form" class="flex lg12">
          <v-flex md12>
            <v-flex md4 offset-md4 text-md-center>
              <v-text-field
                type="text"
                v-model="userName"
                height="42"
                class="username-field"
                :label="$lang.messages.user_id"
                autocomplete="new-password"
                outlined
                hint="Your MyYodlee User ID is username@bankname."
                :rules="[rules.required, rules.syntax]"
                :error="isUsernameinError"
                persistent-hint
                @focus="clearUsernameError"
                autoid="txt-bx-username"
                validate-on-blur
              ></v-text-field>
            </v-flex>
          </v-flex>
          <v-flex md12>
            <v-flex md4 offset-md4 text-md-center>
              <v-text-field
                type="password"
                v-model="password"
                height="42"
                class="password-field"
                label="MyYodlee Password"
                :error="isPasswordinError"
                :rules="[rules.passwordRequired]"
                @focus="clearPasswordError"
                outlined
                autocomplete="new-password"
                @keyup.enter.native="verifyLoginCredentials"
                autoid="txt-bx-password"
                validate-on-blur
              ></v-text-field>
            </v-flex>
          </v-flex>
          <!-- <v-flex md12 xs12>
            <v-flex md4 xs4 offset-md4 offset-xs4>
              <v-checkbox label="Keep me signed in" v-model="checkbox" height="32" hide-details></v-checkbox>
            </v-flex>
          </v-flex>-->
          <v-flex md12>
            <v-flex md4 xs4 offset-md4 offset-xs4>
              <v-btn
                @click="verifyLoginCredentials"
                class="test"
                depressed
                color="primary"
                autoid="btn-log-in"
              >{{ $lang.messages.log_in }}</v-btn>
            </v-flex>
          </v-flex>
        </v-form>
        <v-flex md12>
          <v-flex text-md-center text-lg-center md4 offset-md4>
            <a
              @click="displayPasswordHelp"
              autoid="lnk-forgot-pwd"
            >{{ $lang.messages.forgot_password }}</a>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import serviceRegistery from '../../mixins/serviceRegistery'
import { helpers } from '../../mixins/helpers'

export default {
  components: {},
  data() {
    return {
      valid: true,
      userName: '',
      password: '',
      rules: {
        required: value => !!value || 'Required field.',
        syntax: function(value) {
          let arr = value.split('@')
          if (arr.length === 2 && arr[1].length) {
            return false
          } else {
            return 'MyYodlee User ID should be in the format username@bankname'
          }
        },
        passwordRequired: function(value) {
          if (value) {
            return false
          } else {
            return 'Required field.'
          }
        }
      },
      isPasswordinError: false,
      isUsernameinError: false
    }
  },
  created() {
    this.$store.state.appStore.showHeaderMenu = false
    this.$store.state.appStore.sessionManagement.beginSessionTimer = false
  },
  mixins: [helpers],
  computed: {},
  methods: {
    clearUsernameError() {
      this.isUsernameinError = undefined
    },
    clearPasswordError() {
      this.isPasswordinError = undefined
    },
    verifyLoginCredentials() {
      let self = this

      if (!this.password.length || !this.userName.length || !this.valid) {
        this.isPasswordinError = true
        this.isUsernameinError = true
        this.$store.state.componentStore.yToastMessage = {
          value: true,
          type: 'success',
          message:
            "Uh-oh! You've entered wrong username/ password. Please re-enter credentials"
        }
        this.userName = ''
        this.password = ''
      } else {
        if (!this.$refs.form.validate()) {
          return
        }

        // if (this.userName == 'user@c') {
        //   self.$router.push('/channel')
        //   return
        // }

        if (this.$skipLoginValidation) {
          self.$router.push('/dataloader')
          return
        }

        let uName = this.userName.split('@')[0].trim(),
          appext = this.userName.split('@')[1].trim()

        serviceRegistery
          .makeCall({
            method: 'POST',
            url: this.$hostname + 'services/authenticator/login',
            data: {
              userName: uName,
              password: this.password,
              appext: appext
            },
            headers: {
              utid: this.$store.state.appStore.utid
            }
          })
          .then(response => {
            var data = response.data
            if (data.admin === true) {
              self.$router.push('/channel')
              this.$store.state.appStore.isAdmin = true
            } else {
              self.$router.push('/dataloader')
            }
            this.$store.state.appStore.showHeaderMenu = true
            this.$store.state.appStore.sessionManagement.beginSessionTimer = true
          })
          .catch(error => {
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              var message = error.response.data.message
            }

            if (
              message &&
              (message.indexOf('Invalid') !== -1 ||
                message.indexOf('Channel is not configured') !== -1)
            ) {
              this.showToastMessage('Invalid user credentials')
            } else if (message && message.indexOf('locked') !== -1) {
              this.showToastMessage(
                'Your account has been locked. Please contact Customer care.'
              )
            } else {
              this.showToastMessage(
                'Sorry, a technical error has occurred! Please try again later.'
              )
            }
          })
      }
    },
    displayPasswordHelp() {
      // this.utility.showToastmessage({})
      this.$store.state.componentStore.yToastMessage = {
        value: true,
        type: 'success',
        message:
          'Please contact Yodlee Customer Care at customercare@yodlee.com to reset password'
      }
    }
  }
}
</script>

<style scoped>
.login-header-label {
  height: 24px;
  font-size: 28px;
  font-weight: normal;
  color: #383838;
}
.test {
  width: 100%;
  height: 42px;
  border-radius: 3px;
  margin: 0;
  text-transform: none;
}
.username-hint {
  height: 16px;
  font-size: 12px;
  padding: 0 !important;
}
.username-hint span {
  padding-left: 16px;
}
.v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
.v-input__slot {
  margin-bottom: 0;
}
</style>
